import React, { Component, Suspense, lazy } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Loader from "./loader";

// ROUTES
import OnPageChange from "../utilities/hocs/OnPageChange";

// HEADER & FOOTER
import Header from "../governor-common/components/header/Header";
import Footer from "../governor-common/components/footer/Footer";

// LAZY IMPORT
const Authenticator = lazy(() => import("../components/authenticator"));
// const Enroller = lazy(() => import("../components/enroller"));

const showBranding = !!(process.env?.REACT_APP_BRAND !== "ycsm");
console.log(`Show branding: ${showBranding} ${process.env?.REACT_APP_BRAND}`);

class Routes extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <OnPageChange>
            { showBranding && <Header /> }
            <Switch>
              {/* <Route
                exact
                path={"/enroller"}
                render={() => <Enroller {...this.props} />}
              /> */}
              <Route
                exact
                path={"/"}
                render={() => <Authenticator {...this.props} />}
              />
              <Route
                component={() => {
                  window.location.href = "https://governordao.org";
                  return null;
                }}
              />
            </Switch>
            {showBranding && <Footer /> }
          </OnPageChange>
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default Routes;
